import { useState } from "react";
import { Menu, X } from "lucide-react";
import LogoMark from "./LogoMark";
import { NAV_LINKS } from "../data/content";
import { scrollToSection } from "../lib/scroll";

export default function Nav() {
  const [open, setOpen] = useState(false);

  return (
    <header data-testid="site-nav" className="fixed top-0 inset-x-0 z-50 bg-en-cream/85 backdrop-blur-md border-b border-en-ink/10">
      <div className="h-[3px] bg-gradient-to-r from-en-blue via-en-pink to-en-orange" aria-hidden="true" />
      <div className="max-w-7xl mx-auto px-5 md:px-8 h-16 flex items-center justify-between gap-6">
        <a
          href="#top"
          data-testid="nav-logo-link"
          onClick={scrollToSection("#top")}
          className="flex items-center gap-3 shrink-0"
          aria-label="Eclectically Nelle — home"
        >
          <LogoMark className="w-8 h-8 text-en-ink" />
          <span className="font-mono text-[11px] font-semibold tracking-[0.25em] uppercase leading-tight">
            Eclectically
            <br />
            Nelle
          </span>
        </a>

        <nav className="hidden lg:flex items-center gap-7" aria-label="Primary">
          {NAV_LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              onClick={scrollToSection(l.href)}
              className="font-mono text-[11px] tracking-[0.2em] uppercase opacity-70 hover:opacity-100 hover:text-en-pink transition-colors"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            href="#contact"
            data-testid="nav-hello-button"
            onClick={scrollToSection("#contact")}
            className="hidden sm:inline-flex items-center rounded-full bg-en-ink text-en-cream px-5 py-2 font-mono text-[11px] tracking-[0.2em] uppercase hover:bg-en-pink transition-colors"
          >
            Say hello ↗
          </a>
          <button
            data-testid="nav-menu-toggle"
            className="lg:hidden p-2 -mr-2"
            onClick={() => setOpen((v) => !v)}
            aria-label={open ? "Close menu" : "Open menu"}
            aria-expanded={open}
          >
            {open ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>

      {open && (
        <nav data-testid="nav-mobile-menu" className="lg:hidden border-t border-en-ink/10 bg-en-cream px-5 py-4 flex flex-col gap-1" aria-label="Mobile">
          {NAV_LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-mobile-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              onClick={(e) => {
                setOpen(false);
                scrollToSection(l.href)(e);
              }}
              className="py-3 font-display text-2xl border-b border-en-ink/5 last:border-0"
            >
              {l.label}
            </a>
          ))}
        </nav>
      )}
    </header>
  );
}
